import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Chart } from 'angular-highcharts';
import { Observable, Subject } from 'rxjs';
import { TierV2ColorPipe } from '../../../../shared/tier-v2-color.pipe';
import { CompanyDriverMetric, DriverCurrentTier } from '../../../../types';
import { CompanyService } from '../../../company.service';

@Component({
  selector: 'lohi-driver-tier-chart',
  templateUrl: './driver-tier-chart.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DriverTierChartComponent implements OnInit, OnDestroy {
  @Output() public chartSelected = new EventEmitter<DriverCurrentTier>();
  private destroy$$ = new Subject();
  public labels: Array<string>;
  public chart: Chart;
  public companyDriverMetrics$: Observable<CompanyDriverMetric>;
  public driverCurrentTier: DriverCurrentTier[];

  constructor(
    private companyService: CompanyService,
    private tierV2Color: TierV2ColorPipe,
    private cd: ChangeDetectorRef,
  ) {}

  public ngOnInit(): void {
    this.companyDriverMetrics$ = this.companyService.companyDriverMetrics$;

    this.chart = new Chart({
      chart: {
        type: 'column',
      },
      title: {
        align: 'left',
        useHTML: true,
        text: `<div class="text-lg font-bold">Driver Tier</div>`,
      },
      credits: {
        enabled: false,
      },
      yAxis: [
        {
          labels: {
            enabled: false,
          },
          tickInterval: 0,
          title: { text: null },
        },
        {
          title: { text: 'Points' },
        },
      ],
      plotOptions: {
        series: {
          cursor: 'pointer',
          events: {
            click: (event) => {
              this.chartSelected.emit(event.point.options.custom.data);
            },
          },
        },
      },
      xAxis: {
        type: 'category',
        visible: true,
      },
      series: [],
      tooltip: {
        formatter() {
          return `<span class="font-bold" style="color: ${this.point.color}">` + this.point.name + '</span>: ' + this.y;
        },
      },
    });

    this.companyDriverMetrics$.subscribe((metrics) => {
      if (metrics?.driverCurrentTier?.length > 0) {
        const data = [];
        this.driverCurrentTier = metrics.driverCurrentTier;
        metrics.driverCurrentTier.forEach((info) => {
          data.push({
            custom: {
              data: info,
            },
            name: info.name,
            y: info.totalPoints,
            color: this.tierV2Color.transform(info.tierType),
          });
        });

        this.chart.removeSeries(0);
        this.chart.addSeries(
          {
            name: 'Drivers',
            type: 'column',
            data,
            yAxis: 1,
          },
          true,
          true,
        );
      }
    });

    this.cd.markForCheck();
  }

  public ngOnDestroy() {
    this.destroy$$.next();
    this.destroy$$.unsubscribe();
  }
}
